module.exports = __webpack_public_path__ + "img/backyard-bushes-by-water.dda6a628.jpg";